import { render, staticRenderFns } from "./ErrorMaintenance.vue?vue&type=template&id=124e08aa"
import script from "./ErrorMaintenance.vue?vue&type=script&lang=js"
export * from "./ErrorMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports